export default "__VITE_ASSET__YdkPHN_h__"